<template>
  <div class="modal-backdrop" @click.self="$emit('close')" @keydown="onKeydown">
    <section ref="panel" class="treasure-record-dialog" role="dialog" aria-modal="true" aria-labelledby="treasure-record-title" tabindex="-1">
      <header><h2 id="treasure-record-title">{{ title }}</h2><button ref="closeButton" type="button" aria-label="关闭记录明细" @click="$emit('close')">×</button></header>
      <dl><div v-for="row in rows" :key="row[0]"><dt>{{ row[0] }}</dt><dd>{{ row[1] }}</dd></div></dl>
      <footer><button type="button" class="primary" @click="$emit('close')">关闭</button></footer>
    </section>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
defineProps({ title:String, rows:{type:Array,default:()=>[]} })
const emit=defineEmits(['close'])
const panel=ref(null),closeButton=ref(null)
let previousFocus=null
onMounted(()=>{previousFocus=document.activeElement;closeButton.value?.focus()})
onBeforeUnmount(()=>{if(previousFocus?.isConnected)previousFocus.focus()})
function onKeydown(event){
  if(event.key==='Escape'){event.preventDefault();event.stopPropagation();emit('close');return}
  if(event.key!=='Tab')return
  const buttons=panel.value?.querySelectorAll('button:not(:disabled)')
  if(!buttons?.length)return
  const target=event.shiftKey?buttons[buttons.length-1]:buttons[0]
  if(event.shiftKey&&document.activeElement===buttons[0]||!event.shiftKey&&document.activeElement===buttons[buttons.length-1]){event.preventDefault();target.focus()}
}
</script>
<style scoped>
.treasure-record-dialog{width:min(560px,calc(100vw - 32px));max-height:82dvh;display:flex;flex-direction:column;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 18px 70px #253c572b;}
header,footer{padding:20px 24px;display:flex;align-items:center;justify-content:space-between;gap:16px;flex-shrink:0;}
header{border-bottom:1px solid #e9edf4;}h2{margin:0;font-size:20px;color:#303442;}header button{font-size:28px;color:#65738b;background:transparent;padding:0 8px;line-height:1.2;}
dl{margin:0;padding:4px 24px;overflow-y:auto;}dl div{display:grid;grid-template-columns:42% minmax(0,1fr);gap:16px;padding:16px 0;border-bottom:1px solid #edf0f5;font-size:14px;line-height:1.7;}
dt{color:#65738b;}dd{margin:0;text-align:right;color:#303442;overflow-wrap:anywhere;font-variant-numeric:tabular-nums;}footer{justify-content:flex-end;border-top:1px solid #e9edf4;}button{cursor:pointer;}button:focus-visible{outline:2px solid #179cff;outline-offset:3px;}
@media(max-width:600px){header,footer{padding:16px;}dl{padding:0 16px;}dl div{gap:12px;font-size:13px;}}
</style>
